"use strict";

var _defineProperty = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SlotableMixinImpl = require("./Slotable-impl").implementation;

var CharacterDataImpl = require("./CharacterData-impl").implementation;

var idlUtils = require("../generated/utils");

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var DOMException = require("domexception/webidl2js-wrapper");

var NODE_TYPE = require("../node-type");

var _require2 = require("../../utils"),
    mixin = _require2.mixin; // https://dom.spec.whatwg.org/#text


var TextImpl =
/*#__PURE__*/
function (_CharacterDataImpl) {
  _inherits(TextImpl, _CharacterDataImpl);

  function TextImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, TextImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextImpl).call(this, globalObject, args, _objectSpread({
      data: args[0],
      ownerDocument: idlUtils.implForWrapper(globalObject._document)
    }, privateData)));

    _this._initSlotableMixin();

    _this.nodeType = NODE_TYPE.TEXT_NODE;
    return _this;
  } // https://dom.spec.whatwg.org/#dom-text-splittext
  // https://dom.spec.whatwg.org/#concept-text-split


  _createClass(TextImpl, [{
    key: "splitText",
    value: function splitText(offset) {
      var length = this.length;

      if (offset > length) {
        throw DOMException.create(this._globalObject, ["The index is not in the allowed range.", "IndexSizeError"]);
      }

      var count = length - offset;
      var newData = this.substringData(offset, count);

      var newNode = this._ownerDocument.createTextNode(newData);

      var parent = domSymbolTree.parent(this);

      if (parent !== null) {
        parent._insert(newNode, this.nextSibling);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this._referencedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var range = _step.value;
            var _start = range._start,
                _end = range._end;

            if (_start.node === this && _start.offset > offset) {
              range._setLiveRangeStart(newNode, _start.offset - offset);
            }

            if (_end.node === this && _end.offset > offset) {
              range._setLiveRangeEnd(newNode, _end.offset - offset);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var nodeIndex = domSymbolTree.index(this);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = parent._referencedRanges[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _range = _step2.value;
            var _start2 = _range._start,
                _end2 = _range._end;

            if (_start2.node === parent && _start2.offset === nodeIndex + 1) {
              _range._setLiveRangeStart(parent, _start2.offset + 1);
            }

            if (_end2.node === parent && _end2.offset === nodeIndex + 1) {
              _range._setLiveRangeEnd(parent, _end2.offset + 1);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      this.replaceData(offset, count, "");
      return newNode;
    } // https://dom.spec.whatwg.org/#dom-text-wholetext

  }, {
    key: "wholeText",
    get: function get() {
      var wholeText = this.textContent;
      var next;
      var current = this;

      while ((next = domSymbolTree.previousSibling(current)) && next.nodeType === NODE_TYPE.TEXT_NODE) {
        wholeText = next.textContent + wholeText;
        current = next;
      }

      current = this;

      while ((next = domSymbolTree.nextSibling(current)) && next.nodeType === NODE_TYPE.TEXT_NODE) {
        wholeText += next.textContent;
        current = next;
      }

      return wholeText;
    }
  }]);

  return TextImpl;
}(CharacterDataImpl);

mixin(TextImpl.prototype, SlotableMixinImpl.prototype);
module.exports = {
  implementation: TextImpl
};